import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SignatureGroup } from '../../../models/signature-group';
import { select, Store } from '@ngrx/store';
import { findSignatureGroupAct, saveSignatureGroupAct, updateSignatureGroupAct } from '../../../store/signatures/signatures.actions';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs';
import { SignatureConfiguration } from '../../../models/signature-configuration';
import { User } from '../../../models/user';
import { SignatureType } from '../../../models/signature-type';
import { findSignatureTypeCatalogAct, findUsersWithRolAutCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';

@Component({
  selector: 'app-signatur-edit',
  standalone: false,
  templateUrl: './signatur-edit.component.html',
  styleUrl: './signatur-edit.component.css'
})
export class SignaturEditComponent {

  loading: boolean = true;
  violations: any;
  signatureGroupForm!: NgForm;
  
  signatureGroup: SignatureGroup= new SignatureGroup();
  usersWithRolAut: User[] = [];
  signatureTypes: SignatureType[] = [];

  columndefs : any[] = ['description', 'number','signatureType'];

  ngOnInit(): void {
    
    this.route.paramMap.subscribe(params => {
      const id: number = +(params.get('id') || '0');
      if (id > 0) {
        this.signatureGroupStore.dispatch(findSignatureGroupAct({ id }));
      }else{
        this.signatureGroup = new SignatureGroup();
        this.signatureGroup.active = true;
        this.loading = false;
      }
    });

    this.catalogOfferStore.dispatch(findUsersWithRolAutCatalogAct());
    this.catalogOfferStore.dispatch(findSignatureTypeCatalogAct());

  }

  constructor(
    private signatureGroupStore: Store<{ signatureGroupRdc: any }>,
    private route: ActivatedRoute,
    private catalogOfferStore: Store<{ catalogOfferRdc: any }>,
    private cd: ChangeDetectorRef
  ) {
    this.signatureGroup = new SignatureGroup(); // Inicialización segura por defecto

    this.signatureGroupStore.pipe(
        select('signatureGroupRdc'),
        map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
          signatureGroup: state.signatureGroup,
          violations: state.violations,
          loading: state.loading
        })),
        // evita repeticiones
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      ).subscribe(({ signatureGroup, violations, loading }) => {
      this.violations = violations;
      this.signatureGroup = JSON.parse(JSON.stringify(signatureGroup)); // o mejor: _.cloneDeep(offer)
      
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista
      //console.log("cargando " + this.loading);

      if(this.signatureGroupForm){
        for (const controlName in this.signatureGroupForm.controls) {
          if (this.signatureGroupForm.controls.hasOwnProperty(controlName)) {
            const control = this.signatureGroupForm.controls[controlName];
            if(this.violations[controlName]){
              control.setErrors({'incorrect': true});
              // para las validaciones en campos generados despues de renderizar 
            }
          }
        }
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        usersWithRolAut: state.usersWithRolAut,
        signatureTypes: state.signatureTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ usersWithRolAut, signatureTypes }) => {
      this.usersWithRolAut = usersWithRolAut;
      this.signatureTypes = signatureTypes;
    });

  }

  onSubmit(signatureGroupForm: NgForm): void {
    this.loading = true;
    this.signatureGroupForm = signatureGroupForm;
    const signatureGroupCopy = JSON.parse(JSON.stringify(this.signatureGroup));

    if (signatureGroupCopy.id > 0) {
      this.signatureGroupStore.dispatch(updateSignatureGroupAct({ signatureGroupUpdated: signatureGroupCopy }))
    } else {
      this.signatureGroupStore.dispatch(saveSignatureGroupAct({ signatureGroupNew: signatureGroupCopy }))
    }
    
  }

  addSignature(){
    const newSignatureConfiguration = new SignatureConfiguration();
    newSignatureConfiguration.number = this.signatureGroup.signatureConfigurations.length + 1;
    this.signatureGroup.signatureConfigurations = [...this.signatureGroup.signatureConfigurations, newSignatureConfiguration ];
    this.cd.detectChanges();
  }

  compareSignatureTypes = (a: any, b: any) => a?.id === b?.id;
  compareUsersWithRolAut = (a: any, b: any) => a?.id === b?.id;

}
